
import React from 'react';
import { VictoryPie } from 'victory';


    export const EmptyPieChart: React.FC = () => {
        const emptyAngle = 360 * 0.25; 
        const remainingAngle = 360 - emptyAngle;
        const data = [
          { x: 'Empty', y: emptyAngle, fill: '#BBBBBB' }, 
          { x: 'Remaining', y: remainingAngle, fill: '#828282' }, 
        ];
  return (
    <VictoryPie
    data={data}
      innerRadius={72}
      colorScale={['#BBBBBB', '#828282']}
      labelComponent={<></>} 
    />
  );
};


export const EmptyInvoicePieChart: React.FC = () => {
  const emptyAngle = 360 * 0.25; 
  const remainingAngle = 360 - emptyAngle;
  const data = [
    { x: 'Empty', y: emptyAngle, fill: '#BBBBBB' }, 
    { x: 'Remaining', y: remainingAngle, fill: '#828282' }, 
  ];
return (
  <div className="flex flex-col justify-center ml-[3em] md:ml-0 bigmd:ml-[9em] 540:ml-[3em] 2xl:ml-[7em]">

<div className='px-4 flex justify-center items-center mt-0 md:mt-0  bigmd:mt-0 lg:mt-0   xl:mt-[-6em] ml-[2em] md:ml-0 bigmd:ml-0 lg:ml-0 biglg:mt-[-3em]  w-[164px] md:w-[256px] bigmd:w-[270px] lg:w-[300px] biglg:w-[300px] xl:w-[330px] 2xl:w-[330px] md:justify-center md:items-center 2xl:mt-[-8em] " : `w-[${innerCardWidth}px] h-[${innerCardHeight}px] xl:h-[460px] 2xl:h-[500px] biglg:h-[400px] lg:h-[300px] bigmd:h-[270px]  flex justify-between my-[0px]  mx-[10px] px-2 '>
<VictoryPie
data={data}
innerRadius={72}
colorScale={['#BBBBBB', '#828282']}
labelComponent={<></>} 
/>
</div>
<div className={`text-[12px] xl:text-[17px]  md:text-[14px] lg:text-[14px] text-[#000000] xl:mt-[-6em] ml-0 mt-0 md:mt-0 bigmd:mt-0 lg:mt-[-2em] biglg:mt-[-6em] flex justify-center text-center items-center  `}>
              <p className='text-center '> You do not have any invoice yet. Create an  <span className=' flex justify-center xl:mt-[] '> invoice to see data. </span>  </p> 
          
              </div>
              </div>
);
};


export const EmptyExpensePieChart: React.FC = () => {
  const emptyAngle = 360 * 0.25; 
  const remainingAngle = 360 - emptyAngle;
  const data = [
    { x: 'Empty', y: emptyAngle, fill: '#BBBBBB' }, 
    { x: 'Remaining', y: remainingAngle, fill: '#828282' }, 
  ];
return (
  <div className="flex flex-col justify-center ml-[3em] md:ml-0 bigmd:ml-[9em] 540:ml-[3em] 2xl:ml-[7em]">

<div className='px-4 flex justify-center items-center mt-0 md:mt-0  bigmd:mt-0 lg:mt-0    xl:mt-[-6em] ml-[2em] md:ml-0 bigmd:ml-0 lg:ml-0 biglg:mt-[-3em]  w-[164px] md:w-[256px] bigmd:w-[270px] lg:w-[300px] biglg:w-[300px] xl:w-[330px] 2xl:w-[330px] md:justify-center md:items-center 2xl:mt-[-8em] " : `w-[${innerCardWidth}px] h-[${innerCardHeight}px] xl:h-[460px] 2xl:h-[500px] biglg:h-[400px] lg:h-[300px] bigmd:h-[270px]  flex justify-between my-[0px]  mx-[10px] px-2 '>
<VictoryPie
data={data}
innerRadius={72}
colorScale={['#BBBBBB', '#828282']}
labelComponent={<></>} 
/>
</div>
<div className={`text-[12px] xl:text-[17px]  md:text-[14px] lg:text-[14px] text-[#000000] xl:mt-[-6em] ml-0  540:ml-[-2.3em] mt-0 md:mt-0 bigmd:mt-0 lg:mt-[-2em] biglg:mt-[-6em] flex justify-center text-center items-center  `}>
              <p className='text-center '>  You do not have any expense yet. Create an   <span className=' flex justify-center xl:mt-[] '> expense to see data. </span>  </p> 
          
              </div>
              </div>
);
};